/* import __COLOCATED_TEMPLATE__ from './email-section.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsContactInfoEmailSection extends Component {
  get emailIsRequired() {
    if (this.connection.isCouple) return this.#coupleEmailRequirements;

    if (this.emailTypeAttr === 'emailType') return this.#primaryEmailRequirements;

    return this.connection.isRequiredEmergencyContactEmailAddress;
  }

  get #coupleEmailRequirements() {
    return (
      this.connection.isRequiredEmailAddress ||
      this.connection.isRequiredEmergencyContactEmailAddress
    );
  }

  get #primaryEmailRequirements() {
    if (this.connection.isMinor) return false;

    return this.connection.isRequiredEmailAddress;
  }
}
